import React from 'react';
import { Typography } from '@material-ui/core';

function Page404(props) {
  return (
    <div style={{ padding: '30% 50px' }}>
      <Typography variant="h1" align="center">
        Page Not Found
      </Typography>
    </div>
  );
}

export default Page404;
